import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

import { useGetFirstInteractionChartQuery } from '../../../../app/services/chatbot-rtk.services';
import LoadingComponent from '../../../common/loading/loading.component';

interface ChartProps {
  from: string;
  to: string;
  botId: string;
}

const ConversationChart: React.FC<ChartProps> = ({ from, to, botId }) => {
  const { t, i18n } = useTranslation();
  const { data, error, isLoading, refetch, isFetching } = useGetFirstInteractionChartQuery({
    from,
    to,
    botId,
  });

  useEffect(() => {
    refetch();
  }, [from, to]);

  const [chartData, setChartData] = useState<any>(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    setChartData(null);
    if (data) {
      let total = 0;
      data.forEach((item: any) => {
        const sum = Number(item?.count) ?? 0;
        total = sum + total;
      });

      setCount(total);

      setChartData({
        labels: data.map((dr: any) => dr.date),
        datasets: [
          {
            label: '',
            data: data.map((dr: any) => Number(dr?.count) ?? 0),
            backgroundColor: ['#312ee3'],
            borderColor: ['#312ee3'],
            borderWidth: 1,
          },
        ],
      });
    }
  }, [data, isFetching]);

  const config = {
    type: 'bar',
    data: chartData,
    options: {
      scales: {
        y: {
          ticks: {
            callback: function (value: any) {
              if (typeof value === 'number' && value % 1 === 0) {
                return value;
              } else {
                return '';
              }
            },
            stepSize: 10,
          },
        },
      },
    },
  };

  if (isLoading)
    return (
      <div>
        <LoadingComponent />
      </div>
    );
  if (error)
    return (
      <div>
        <LoadingComponent />
      </div>
    );
  return (
    <div className="tw-flex tw-flex-col  tw-max-h-80 tw-w-full tw-my-2">
      <div className="tw-text-gray-800 tw-text-base tw-font-semibold tw-font-['Lexend'] tw-uppercase">{t('Charts/Conversations/title')}</div>
      {count !== 0 ? (
        <div className="tw-text-gray-800 tw-text-3xl tw-font-medium tw-font-['Lexend']">{count}</div>
      ) : (
        <div className="tw-text-gray-400 tw-text-xl tw-font-medium tw-font-['Lexend']">{t('Charts/NoData')}</div>
      )}
      <div className="tw-text-gray-800 tw-text-base tw-font-normal tw-font-['Lexend']">{`${count !== 0 ? t('Charts/Conversations/description') : ''}`}</div>

      {chartData && count !== 0 && (
        <div className=" tw-w-full">
          <Bar data={config.data} options={config.options} />
        </div>
      )}
    </div>
  );
};

export default ConversationChart;
